import { fetcher } from '@commenda/utils';
import { UpdateTransferPricingOnboardingParams } from './types';

const updateTransferPricingOnboarding = async (
  serviceProviderEntityId: number,
  body: UpdateTransferPricingOnboardingParams
) => {
  const res = await fetcher(
    `transfer-pricing/onboarding/${serviceProviderEntityId}`,
    {
      method: 'POST',
      body,
    }
  );

  return res;
};

export { updateTransferPricingOnboarding };
